import { useEffect, useState } from "react";

export default function ContactForm() {
  const [startTime, setStartTime] = useState("");
  const [errors, setErrors] = useState({});
  useEffect(() => {
    setStartTime(Date.now().toString());
  }, []);

  async function handleSubmit(e) {
    // Prevent browser refresh
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);

    // client-side validation
    const newErrors = {};
    if (!formData.get("nome"))
      newErrors.nome =
        "Por favor, não se esqueça de o preencher o seu nome, este é um campo obrigatório.";
    if (!formData.get("email"))
      newErrors.email =
        "Por favor, não se esqueça de o preencher o seu endereço de email, este é um campo obrigatório.";
    if (!formData.get("telefone"))
      newErrors.telefone =
        "Por favor, não se esqueça de o preencher o seu contacto telefónico, este é um campo obrigatório.";
    if (!formData.get("mensagem"))
      newErrors.mensagem =
        "Por favor insira a sua mensagem, este campo é obrigatório.";

    setErrors(newErrors);

    // Stop submission if there are validation errors
    if (Object.keys(newErrors).length > 0) return;

    formData.append("formRenderedAt", startTime);
    formData.append("formSubmittedAt", Date.now().toString());

    const formJson = Object.fromEntries(formData.entries());
    // console.log(formJson);
    try {
      const response = await fetch(
        "https://keidge.com/wp/wp-json/custom/v1/contact",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formJson),
        }
      );

      const data = await response.json();

      if (response.ok && data.success) {
        alert("Mensagem enviada com sucesso!");
        form.reset();
        setErrors({});
      } else {
        alert(data.message || "Ocorreu um erro ao enviar a mensagem.");
      }
    } catch (error) {
      console.error("Erro ao enviar:", error);
      alert("Erro de ligação ao servidor. Tente novamente mais tarde.");
    }
  }

  return (
    <form method onSubmit={handleSubmit}>
      <div className="form-fields">
        <div>
          <div>
            <label for="nome-cliente">Nome*</label>
            <input
              type="text"
              name="nome"
              id="nome-cliente"
              aria-describedby={errors.nome ? "nome-erro" : undefined}
              aria-invalid={!!errors.nome}
              required
            />
            {errors.nome && (
              <span id="nome-erro" role="alert">
                {errors.nome}
              </span>
            )}
          </div>
          <div>
            <label for="email-cliente">E-mail*</label>
            <input
              type="email"
              name="email"
              id="email-cliente"
              aria-describedby={errors.email ? "email-erro" : undefined}
              aria-invalid={!!errors.email}
              required
            />
            {errors.email && (
              <span id="email-erro" role="alert">
                {errors.email}
              </span>
            )}
          </div>
          <div>
            <label for="telefone-cliente">Telefone*</label>
            <input
              type="tel"
              name="telefone"
              id="telefone-cliente"
              aria-describedby={errors.telefone ? "tel-erro" : undefined}
              aria-invalid={!!errors.telefone}
              required
            />
            {errors.telefone && (
              <span id="tel-erro" role="alert">
                {errors.telefone}
              </span>
            )}
          </div>
        </div>
        <div>
          <div>
            <label for="servicos-keidge">
              Escolha um Serviço:<small>(campo opcional)</small>
            </label>
            <select id="servicos-keidge" name="servicos">
              <option value="documentario">Documentário</option>
              <option value="filme-publicitario">Filme Publicitário</option>
              <option value="videoclip">Videoclip</option>
              <option value="reportagem-evento">Reportagem de Evento</option>
              <option value="video-institucional">Vídeo Institucional/ Promocional</option>
              <option value="trabalho-estudio">Trabalho de Estúdio</option>
              <option value="livestream">Livestream</option>
              <option value="outro">Outro</option>
            </select>
          </div>
          <div>
            <label for="mensagem-cliente">Mensagem*</label>
            <textarea
              id="mensagem-cliente"
              name="mensagem"
              aria-describedby={errors.mensagem ? "mensagem-erro" : undefined}
              aria-invalid={!!errors.mensagem}
              required
              rows="7"
            ></textarea>
            {errors.mensagem && (<span id="mensagem-erro">
              {errors.mensagem}
            </span>)}
          </div>
          <div className="buttons-block">
            <button type="reset" onClick={() => setErrors({})}>Cancelar</button>
            <button type="submit">Enviar Mensagem</button>
          </div>
        </div>
      </div>
    </form>
  );
}
